import React from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {
    return (
        <div 
            className="relative h-[70vh] md:h-[85vh] flex items-center justify-center bg-cover bg-center mt-16"
            style={{ 
                backgroundImage: 'url("https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop")',
                backgroundAttachment: 'fixed'
            }}
        >
            <div className="absolute inset-0 bg-slate-900 bg-opacity-65"></div>
            <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-7xl font-black text-white mb-6 drop-shadow-2xl tracking-tight leading-tight">
                    Discover Your Next <span className="text-amber-500 block md:inline">Adventure</span>
                </h1>
                <p className="text-base md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto font-medium leading-relaxed">
                    Join one of the largest and most trusted travel companies to explore the world's most breathtaking destinations.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link to="/tours" className="w-full sm:w-auto">
                        <button className="w-full sm:w-auto bg-amber-500 hover:bg-amber-400 text-slate-900 font-black py-4 px-10 rounded-2xl shadow-2xl transition-all hover:-translate-y-1 hover:shadow-amber-500/20 text-lg uppercase tracking-widest">
                            Explore Tours
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Banner;